<template>
	<!--컨텐츠-->
	<div class="contents">
		<div class="contents__wrap">
	
			<!--페이지 상단-->
			<div class="sub-top">
				<h3>공지 등록</h3>
				<div class="sub-top__navi">
					<span class="icon-home navi--home"></span>
					<span>공지 관리</span>
				</div>
			</div>
	
			<!-- 로딩 화면 -->
			<div v-if="isLoading" class="loading-overlay">
				<div class="spinner"></div>
				<p>저장 중입니다. 잠시만 기다려주세요...</p>
			</div>
	
			<!--공지 등록-->
			<div class="board-write spacing--xs">
				<table class="table table--break">
					<colgroup>
						<col style="width:20%;">
						<col style="width:auto;">
					</colgroup>
					<tr>
						<th>대상기관</th>
						<td>
							<div>
								<select v-model="searchOrg" :disabled="checkUserId.organizationCode !== 'A00001' && checkUserId.privilege !== 'sAdmin'">
									<option value="">전체</option>
									<option v-for="(org, index1) of orgDataList" :key="index1" :value="org.organizationCode">{{org.organizationName}}</option>
								</select>
							</div>
						</td>
					</tr>
					<tr>
						<th>제목</th>
						<td><input type="text" v-model="insertTitle" placeholder="내용을 입력해 주세요"></td>
					</tr>
					<tr>
						<th>내용</th>
						<td>
							<textarea placeholder="내용을 입력해주세요" v-model="insertContent" ></textarea>
						</td>
					</tr>
					<tr>
						<th>파일첨부</th>
						<td colspan="2" >
							<input type="file" class="attach-btn" id="attach_ex1" @input="selectFile">
							<img
							class="doc-background"
							v-if="noticeInfo.file && isImageFile(noticeInfo.file.fileNm)"
							:src="noticeInfo.filePreview"
							/>
							<div>
								<label for="attach_ex1" class="btn btn--sm btn--secondary">파일첨부</label>
								<ul class="attach-list">
									<li>
										<span v-if="noticeInfo.file">{{ noticeInfo.file.fileNm }}</span>
										<button type="button" class="icon-x" v-if="noticeInfo.file" @click="selectIconX"></button>
									</li>
								</ul>
							</div>
						</td>
					</tr>

					<tr v-if="searchOrg === ''">
						<th>중요 공지 설정</th>
						<td><input type="number" v-model="pinnedOrder" placeholder="숫자만 입력해주세요"></td>
					</tr>

				</table>
			</div>
			<div class="btns btns--center spacing--xs">
				<button type="button" @click="goBack()" class="btn btn--sm btn--basic icon-x">닫기</button>
				<button type="button" @click="goSave()" class="btn btn--sm btn--primary icon-check" v-if ="checkUserId.privilege != 'user'"> 등록</button>
			</div>
		</div>
	</div>
	</template>
	
	<script setup>
	import { useStore } from 'vuex'
	import { ref, computed, onMounted, onUnmounted } from 'vue'
	import { useRouter } from 'vue-router'
	import { insertNotice } from '@/api/notice'
	import * as Utils from '@/common/util/util'
	
	const store = useStore()
	const router = useRouter()
	
	const insertTitle = ref('')
	const insertContent = ref('')
	const pinnedOrder = ref('')
	const isLoading = ref(false) // 로딩 상태 변수 추가
	const checkUserId = computed(() => store.state.temp.userInfo )
	const noticeInfo = store.state.notice.noticeInfo
	
	const orgDataList = computed(() => {
		return store.state.grid.orgData
	})
	
	const searchOrg = ref('') // 초기값을 빈 문자열로 설정
	
	const checkField = () => {
		if (insertTitle.value == '') {
			alert("제목을 입력해 주세요.")
			return false
		}
		if (insertContent.value == '') {
			alert("내용을 입력해 주세요.")
			return false
		}
		if (Utils.isEmpty(checkUserId.value.memberCode)) {
			alert("유저 ID를 가져오는데 실패했습니다.")
			return false
		}        
		return true
	}
	
	const goSave = async () => {
		if (!checkField()) { return false }
	
		if (confirm("저장하시겠습니까?")) {
			isLoading.value = true; // 로딩 시작
			try {
				const params = new FormData()
				params.append("noticeTitle", insertTitle.value)
				params.append("noticeContent", insertContent.value)
				params.append("memberCode", checkUserId.value.memberCode)
				
				if(searchOrg.value == "" && pinnedOrder.value != '' ){
					params.append("pinnedOrder", pinnedOrder.value)
				}
				
				params.append("organizationCode", searchOrg.value)
				if(noticeInfo.file.file != null){
					params.append("noticeInputFile", noticeInfo.file.file)
				}
	
				const resultVo = await insertNotice(params)
	
				if (resultVo?.result == 'ok') {
					alert(resultVo.resultMsg)
					router.push({ name: 'noticeList' })
					store.commit('notice/clearNoticeInfo')
				} else {
					alert(resultVo.resultMsg)
					store.commit('notice/clearNoticeInfo')
				}
			} catch (error) {
				console.error("저장 중 오류 발생:", error);
			} finally {
				isLoading.value = false; // 로딩 종료
			}
		}
	}
	
	// 첨부된 파일이 이미지인지 아닌지 확인인
	const isImageFile = (fileName) => {
		const imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'];
		const extension = fileName?.split('.').pop()?.toLowerCase(); // 확장자 추출
		return imageExtensions.includes(extension); // 확장자가 이미지인지 확인
	};


	const goBack = () => {
		router.push({ name: 'noticeList' })
	}
	
	// 파일 선택
	const selectFile = (e) => {
		var input = e.target.files[0]
		var flag = false
	
		if (input != null) {
			if (Utils.isNotEmpty(noticeInfo.file) && noticeInfo.file.fileNm === input.name) {
				flag = true
			}
	
			if (!flag) {
				var fileObject = {
					file: input,
					fileNm: input.name,
					preview: window.URL.createObjectURL(input),
					type: e.target.id
				}
				if(fileObject.type === 'attach_ex1'){
					noticeInfo.filePreview = fileObject.preview
					noticeInfo.file = fileObject
				}
			} else {
				alert('이미 선택한 파일입니다.')
				return
			}
		} else {
			return
		}
	}
	
	const selectIconX = (() => {
		noticeInfo.file = ''
		const fileInput = document.getElementById('attach_ex1');
		fileInput.value = '';
	})
	
	const getComboData = async () => {
		await store.dispatch('grid/fetchOrg')
	}
	
	onMounted(async () => {
		await getComboData()	
		if(checkUserId.value.organizationCode != "A00001" && checkUserId.value.privilege != 'sAdmin'){
			searchOrg.value = checkUserId.value.organizationCode;
		}

	})
	</script>
	
	<style scoped>
	.loading-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		color: white;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		z-index: 1000;
	}
	
	.spinner {
		border: 5px solid rgba(255, 255, 255, 0.3);
		border-top: 5px solid white;
		border-radius: 50%;
		width: 50px;
		height: 50px;
		animation: spin 1s linear infinite;
	}
	
	@keyframes spin {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}
	</style>
	